module.exports = __webpack_public_path__ + "img/k2.5862a1b0.jpg";